module.exports = __webpack_public_path__ + "static/super-admin-product-page-7ef4e03655a71f131fbf0b2138cc5392.png";